module.exports = __webpack_public_path__ + "static/img/A1.68c74f86.jpg";